import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import AddIcon from "../../../../public/images/add-black.svg";
import TextIcon from "../../../../public/images/text-aa.svg";
import { cls } from "app/utils";
import useCloseOnOutsideClick from "./useCloseOnOutsideClick";

interface AddNewMenuProps {
  onAddResource: () => void;
  onAddSection: () => void;
}

/**
 * The one add entry of the Resources page (Figma 68:8877). It opens a menu
 * with a resource and a section. The button is the grey pill of the Figma
 * button family, at every width.
 */
const AddNewMenu: React.FC<AddNewMenuProps> = ({
  onAddResource,
  onAddSection,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useCloseOnOutsideClick(menuRef, open, () => setOpen(false));

  const choose = (action: () => void) => {
    setOpen(false);
    action();
  };

  return (
    <div className={styles.add_new} ref={menuRef}>
      <button
        type="button"
        className={cls(
          styles.pill_button,
          styles.pill_secondary,
          styles.add_new_button,
        )}
        onClick={() => setOpen(!open)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <img src={AddIcon} alt="" width={24} height={24} />
        {t("Add New")}
      </button>
      {open && (
        <div className={styles.action_menu} role="menu" data-testid="add-new-menu">
          <button
            type="button"
            role="menuitem"
            className={styles.menu_item}
            onClick={() => choose(onAddResource)}
          >
            <img src={AddIcon} alt="" width={24} height={24} />
            {t("Resource")}
          </button>
          <button
            type="button"
            role="menuitem"
            className={styles.menu_item}
            onClick={() => choose(onAddSection)}
          >
            <img src={TextIcon} alt="" width={24} height={24} />
            {t("Section")}
          </button>
        </div>
      )}
    </div>
  );
};

export default AddNewMenu;
